module.exports = __webpack_public_path__ + "img/Sohan.c24bd1a6.jpg";